package fr.manyverse.app.domain.model

data class GmTimer(
    val id: String,
    val durationSeconds: Int,
    val remainingSeconds: Int,
    val isPaused: Boolean,
    val continueAfterEnd: Boolean = false,
    val overtimeSeconds: Int = 0
)
